$(document).ready(() => {
    $('body').on('click', '#footer .title-toggle', function() {
        $(this).toggleClass("open");
    });
});